import request from '../utils/request';

// 根据ID获取商家经营信息详情
export function getMerchantBusinessInfoById(id) {
  return request({
    url: `/merchant-business-info/${id}`,
    method: 'get'
  });
}

// 分页查询商家经营信息列表
export function listMerchantBusinessInfos(params) {
  return request({
    url: '/merchant-business-info/list',
    method: 'post',
    data: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      startTime: params.startTime,
      endTime: params.endTime,
      sortField: params.sortField || 'createTime',
      sortOrder: params.sortOrder || 'desc',
      ...params
    }
  });
}

// 新增商家经营信息
export function addMerchantBusinessInfo(data) {
  return request({
    url: '/merchant-business-info/add',
    method: 'post',
    data
  });
}

// 更新商家经营信息
export function updateMerchantBusinessInfo(data) {
  return request({
    url: '/merchant-business-info/update',
    method: 'put',
    data
  });
}

// 删除商家经营信息
export function deleteMerchantBusinessInfoById(id) {
  return request({
    url: `/merchant-business-info/${id}`,
    method: 'delete'
  });
}
